import { render, staticRenderFns } from "./BookingProductsTable.vue?vue&type=template&id=d0bc8de8&lang=pug&"
import script from "./BookingProductsTable.vue?vue&type=script&lang=js&"
export * from "./BookingProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports